// extracted by mini-css-extract-plugin
export default {"container":"QY-z","list":"RY-z"};